import React from 'react'
import AboutIcon from '../../assets/img/logo/favicon.png';
import { Link } from 'react-router-dom';
import empowerImg from '../../assets/img/empower.png'
import Shape from '../../assets/img/shape-2.png'
import { Helmet } from "react-helmet-async";
import CardImg from '../../assets/img/scan.png'

function PaymentLink() {
    const dashboardBaseUrl = process.env.REACT_APP_DASHBOARD_BASE_URL;
    return (
        <>
            <Helmet>
                <title>Payment Link</title>
                <meta name="description" content="Payment Link " />
            </Helmet>
            <section className='breadcrumb__section__02 padding__tb__100'>
                <div className="container">
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className="breadcrumb__title__head">
                                <ol className="breadcrumb">
                                    <li className="active"><img src={AboutIcon} style={{ width: '25px', height: '25px' }} alt="" /></li>
                                </ol>
                                <h2 className='breadcrumb__title'> FEATURES </h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="breadcrumb__text">
                                <h3 className='breadcrumb__text__head'>Payment Links</h3>
                                <p className='breadcrumb__text__content '>
                                    Africa’s rich cultural diversity and entrepreneurial spirit drive its growing economy. Our Payment Links reflect this dynamism by connecting people, businesses, and ideas across borders, fostering a sense of unity and collaboration.
                                </p>
                            </div>
                            <div className='d-flex gap-3 justify-content-center align-items-center' style={{ paddingTop: '40px' }}>
                                <Link to='' className='btn btn__primary'>Generate Link</Link>
                                <Link to='/contact' className='btn btn__outline_primary '>Contact us</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='virtual__section payment__link__section padding__tb__100'>
                <div className='container'>
                    <div className='row justify-content-around align-items-center' >
                        <div className='col-12 col-md-7 mb-4 mb-lg-0 '>
                            <div className='virtual__section__content'>
                                <h3>
                                    Partnering in Africa’s journey toward financial inclusion and prosperity
                                </h3>
                                <p>
                                    Our Payment Link feature is an innovative solution designed to simplify how you collect payments across Africa.
                                </p>
                                <a className='btn btn__primary mt-4' href={`${dashboardBaseUrl}/getstarted`} target="_blank" rel="noopener noreferrer">
                                    Get Started
                                </a>
                            </div>
                        </div>
                        <div className='col-12 col-md-5 mb-4 mb-lg-0 '>
                            <div className='payment__link__section__image d-flex justify-content-end align-items-center'>
                                <img src={CardImg} className='img-fluid' alt='virtual cards' />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='payment__link__feature padding__tb__50'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-md-12'>
                                <div className='payment__link__feature__content'>
                                    <div className='payment__link__feature__content__icon'>
                                        <img src={Shape} className='img-fluid' alt='virtual cards' />
                                    </div>
                                    <p>
                                        Our Payment Link feature is our way of creating a future where every African can participate in and benefit from the global digital economy in terms of sending and receiving money.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>



            <section className='create__virtual__card__section padding__tb__50'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='position-relative'>
                                <h2 className='create__virtual__card__section__title'>How to create Payment Link:</h2>
                            </div>
                        </div>
                    </div>
                    <div className='create__virtual__account__section__content'>
                        <div className='create__virtual__account__section__content_right'>
                            <div className='create__virtual__card__section__content__item'>
                                <div className='create__virtual__card__section__content__item__box mb-4'>
                                    <div className='create__virtual__card__section__content__item__box__icon'>
                                        1
                                    </div>
                                    <div className='create__virtual__account__item'>
                                        <h4>Login to your account</h4>
                                        <p>Access your Cardplot dashboard through the app or website.</p>
                                    </div>
                                </div>
                                <div className='create__virtual__card__section__content__item__box mb-4'>
                                    <div className='create__virtual__card__section__content__item__box__icon'>
                                        2
                                    </div>
                                    <div className='create__virtual__account__item'>
                                        <h4>Go to payment links</h4>
                                        <p>Select the "Payment Links" option and click "Create New Link."
                                            
                                        </p>
                                    </div>
                                </div>
                                <div className='create__virtual__card__section__content__item__box mb-4'>
                                    <div className='create__virtual__card__section__content__item__box__icon'>
                                        3
                                    </div>
                                    <div className='create__virtual__account__item'>
                                        <h4>Customize Your Link</h4>
                                        <p>Enter the amount, purpose, and any additional details for the payment request.</p>
                                    </div>
                                </div>
                                <div className='create__virtual__card__section__content__item__box mb-4'>
                                    <div className='create__virtual__card__section__content__item__box__icon'>
                                        4
                                    </div>
                                    <div className='create__virtual__account__item'>
                                        <h4>Share and Receive Payments</h4>
                                        <p>Generate the link and share it with your customers or contacts to receive payments instantly.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='empower_your_trade overlay'>
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-12 col-lg-6 mb-4 mb-lg-0">
                            <div className="empower__title">
                                <h2>Ready to simplify your payments?</h2>
                                <p>Simplify Your Exchange, Empower Your Trade</p>
                                <div className='d-flex gap-3' style={{ paddingTop: '60px' }}>
                                    <a className='btn btn__primary' href={`${dashboardBaseUrl}/getstarted`} target="_blank" rel="noopener noreferrer">
                                        Get Started
                                    </a>
                                    <Link to='/contact' className='btn btn__outline_primary'>Contact us</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-6 mb-4 mb-lg-0">
                            <div className="empower__img">
                                <img src={empowerImg} className='img-fluid' alt="empower" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default PaymentLink